if (customElements.get('product-form') === undefined) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      if (this.getVariantData().length > 1) {
        this.form.addEventListener('change', this.onVariantChange.bind(this));
      }
    }

    serializeForm (form) {
      const obj = {};
      const formData = new FormData(form);
      for (const key of formData.keys()) obj[key] = formData.get(key);
      return JSON.stringify(obj);
    }

    onVariantChange() {
      this.updateOptions();
      this.updateVariantId();
      this.removeErrorMessage();

      if (!this.currentVariant) {
        this.setUnavailable();
      } else {
        this.updateVariantInput();
        this.setButtonState(this.currentVariant.available);
        this.renderProductInfo();
        this.updateURL();
      }
    }

    onSubmitHandler(event) {
      event.preventDefault();

      this.handleErrorMessage();

      this.submitButton = this.querySelector('[name="add"]');
      this.submitButton.setAttribute('disabled', true);
      this.submitButton.classList.add('loading');

      this.fetchConfig = { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' }};
      this.fetchConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
      this.fetchConfig.body = JSON.stringify({
        ...JSON.parse(this.serializeForm(this.form)),
        sections_url: window.location.pathname
      });

      fetch(`${routes.cart_add_url}`, this.fetchConfig)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { response } }));
        })
        .catch((error) => { console.error(error) })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('disabled');
        }
      );
    }

    updateOptions() {
      this.selectType = this.querySelector('[data-options-type]');

      if (!this.selectType) return;

      if (this.selectType.dataset.optionsType == 'dropdowns') {
        this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
      } else {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => {
          return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        });
      }
    }

    updateVariantId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateVariantInput() {
      this.productContainer = this.closest('[data-product]');
      if (!this.productContainer) return;

      this.productForms = this.productContainer.querySelectorAll('[data-form="product-form"]');
      if (!this.productForms) return;

      this.productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
      });

      document.dispatchEvent(new CustomEvent('variant:change', { detail: this.currentVariant }));
    }

    updateURL() {
      if (!this.currentVariant || !window.location.pathname.includes('/products/')) return;
      window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }

    setButtonState(available) {
      this.addToCartButton = this.querySelector('[name="add"]');
      if (!this.addToCartButton) return;

      if (!available) {
        this.addToCartButton.setAttribute('disabled', true);
        this.addToCartButton.textContent = window.language.soldOut;
      } else {
        this.addToCartButton.removeAttribute('disabled');
        this.addToCartButton.textContent = window.language.addToCart;
      }
    }

    setUnavailable() {
      this.addToCartButton = this.querySelector('[name="add"]');
      if (!this.addToCartButton) return;
      this.addToCartButton.setAttribute('disabled', true);
      this.addToCartButton.textContent = window.language.unavailable;

      this.closest('[data-product]').querySelector('product-price')?.classList.add('visually-hidden');
    }

    renderProductInfo() {
      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const productPrice = 'product-price';
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.querySelector(productPrice);
        const source = html.querySelector(productPrice);

        if (source && destination) destination.innerHTML = source.innerHTML;

        this.closest('[data-product]').querySelector('product-price')?.classList.remove('visually-hidden');
      });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.error-message');
      this.errorMessageContent = this.errorMessageContent || this.errorMessageWrapper.querySelector('.error-message--content');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) this.errorMessageContent.textContent = errorMessage;
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }
  }

  customElements.define('product-form', ProductForm);
}
